import { render } from "./AccountLayout.vue?vue&type=template&id=afe33d66&scoped=true"
import script from "./AccountLayout.vue?vue&type=script&lang=js"
export * from "./AccountLayout.vue?vue&type=script&lang=js"

import "./AccountLayout.vue?vue&type=style&index=0&id=afe33d66&lang=scss&scoped=true"

import exportComponent from "E:\\dive\\dive.fsd.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afe33d66"]])

export default __exports__